import cache from './cache.js';
import getUserAgent from './getUserAgent.js';
import regex from './isWindowsMobile.json';

export default cache('isWindowsMobile', function isWindowsMobile() {
  const pattern = new RegExp(...regex);
  return pattern.test(getUserAgent());
});